import * as Path from './apiRoutes';
import ApiService from "../../../../utils/apiService";
import { MSG_DEFAULT_ERROR } from "../../../../utils/messages";
import { NOTIF_ERROR } from "../../../../utils/constants";
import { SideNotification } from "../../../../utils/common";
import moment from 'moment';
import * as Actions from './actions';

export const getAdsList = (storeId, search) => (dispatch) => {
    let params = new FormData();
    params.append("pstoreId", storeId)
    params.append("pstrSearch", search)
    params.append("pboolWithInactive", true)
    return ApiService.list(Path.ADS_ROOT, params)
        .then((response) => {
            dispatch(Actions.setList(response.data.data));
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const getPendingAdsList = (data, storeId) => () => {
    let params = new FormData();
    
    params.append("paginationDetails", JSON.stringify(data));
    params.append("pstoreId", storeId)
    return ApiService.post(Path.ADS_ROOT + "/list/pending", params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const getAdsById = (id) => () => {
    return ApiService.get(Path.ADS_ROOT + `/${id}`)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const sortDraggable = (sortedAds) => () => {
    return ApiService.post(Path.ADS_DRAGGABLE, sortedAds)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const deleteAd = (id) => () => {
    return ApiService.delete(Path.ADS_ROOT, id)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const insertAd = (adDetails, imageFile, isAdmin) => () => {
    adDetails.startDate = moment(adDetails.startDate);
    adDetails.endDate = moment(adDetails.endDate);

    const params = new FormData();
    params.append("adDetails", JSON.stringify(adDetails));
    params.append("imageFile", imageFile);
    params.append("isAdmin", isAdmin);

    if(isAdmin){
        return ApiService.insert(Path.ADS_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }else{
        return ApiService.storePublicInsert(Path.ADS_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
    }
    
};

export const updateAd = (adDetails, imageFile) => () => {
    adDetails.startDate = moment(adDetails.startDate);
    adDetails.endDate = moment(adDetails.endDate);

    const params = new FormData();
    params.append("adDetails", JSON.stringify(adDetails));
    params.append("imageFile", imageFile);
    return ApiService.update(Path.ADS_ROOT, params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
};

export const approveAd = (adsId) => () =>{
    const params = new FormData();
    params.append("adsId", adsId);
    return ApiService.post(Path.ADS_ROOT + "/approve", params)
        .then((response) => {
            return response.data;
        })
        .catch(() => SideNotification(NOTIF_ERROR, MSG_DEFAULT_ERROR))
}